import { WebClientListResourceFetcher } from '~commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';

import { ServerApiMapper } from '../../ts/helpers/ServerModelHelper';
import { IListResource } from '../../ts/resources/Resource';
import { ResourceQuery } from '../../ts/resources/ResourceQuery';
import { GetWorkbookAccelerationsRequest } from '../../workbook/ServerApi/requests/dataAcceleration/GetWorkbookAccelerationsRequest';
import { IWorkbookAccelerationInfo } from '../../workbook/ServerApi/types/dataAcceleration/IWorkbookAccelerationInfo';

export class WorkbookAccelerationsResource implements IListResource<IWorkbookAccelerationInfo> {

  private listFetcher = new WebClientListResourceFetcher(GetWorkbookAccelerationsRequest, ServerApiMapper.workbookAccelerations);

  public all(): ResourceQuery<IWorkbookAccelerationInfo> {
    return new ResourceQuery(this.listFetcher);
  }
}

export const WorkbookAccelerations = new WorkbookAccelerationsResource();
